import account from './account'
import alert from './alert'
import editor from './editor'
import progress from './progress'
import projects from './projects'
import galleries from './galleries'

export default {
  account,
  alert,
  editor,
  galleries,
  progress,
  projects
}



// WEBPACK FOOTER //
// ./src/store/modules/index.js